import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/main.scss'
import { captureBootDeepLink } from '@/composables/useNotifyDeepLink'
import { bindSwVibrateBridge } from '@/composables/useSchedulePush'
import { syncAppClientVersion } from '@/utils/appClientVersion'

// 현재 앱 버전만 기록. 업데이트해도 로그인은 유지
syncAppClientVersion()

// 알림 클릭으로 앱이 열릴 때 딥링크·SW 메시지 유실 방지 (스플래시보다 먼저)
captureBootDeepLink()
bindSwVibrateBridge()

createApp(App).use(router).mount('#app')
